import { Navigate, useLocation, useParams } from 'react-router';

/**
 * The dashboard used to live under the locale (`/hi/app/keys`). The locale layout around this
 * route has switched to that language and remembered it; this keeps the rest of the address.
 */
export function LegacyAppRedirect() {
  const { '*': rest = '' } = useParams();
  const { search, hash } = useLocation();
  return <Navigate to={`/app${rest === '' ? '' : `/${rest}`}${search}${hash}`} replace />;
}
